module.exports = [
  { id: 1, value: 'Visa' },
  { id: 2, value: 'Mastercard' },
  { id: 3, value: 'American Express' },
  { id: 4, value: 'Discover' }
];
